
export const wide = window.matchMedia( '(min-width: 768px)' );
export const narrow = window.matchMedia( '(max-width: 767px)' );

export const matchesNarrow = () => {
  return narrow.matches;
};

export const matchesWide = () => {
  return wide.matches;
};



// WEBPACK FOOTER //
// ./src/js/mq.js